import { Button } from "antd";
import { bg_tonemusic, logo_mini_tonemusic } from "assets";
import {
  AlertConfirm,
  AlertError,
  AlertSuccess,
  AlertWarning,
} from "components/alert/Alert";
import { COLOR } from "constants/color";
import { errorToMessage } from "hooks/functions/errorToMessage";
import { useState } from "react";
import { Link } from "react-router-dom";
import masterService from "services/master.services";
import {
  useNavigate,
  useParams,
} from "../../../node_modules/react-router-dom/dist/index";

const backgroundStyle = {
  margin: 0,
  padding: 0,
  backgroundImage: `url(${bg_tonemusic})`,
  backgroundSize: "cover",
  backgroundAttachment: "fixed",
  backgroundRepeat: "no-repeat",
  height: "100vh",
};

const text = {
  color: "#424242",
  opacity: "0.6",
  fontSize: "20px",
};

const header = {
  color: COLOR.primary,
  fontWeight: "bold",
  fontSize: "40px",
  lineHeight: "34px",
};

const ChangePassword = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [newPassword, setNewPassword] = useState(null);
  const [confirmPassword, setConfirmPassword] = useState(null);

  const { mutate: changePassword } = masterService.useMutationChangePassword(
    () => {
      AlertSuccess({
        onOk: () => {
          navigate("/login");
        },
      });
    },
    (err) => {
      AlertError({ text: errorToMessage(err) });
    }
  );

  const _handleResetPassword = () => {
    AlertConfirm({
      onOk: () => {
        if (newPassword !== confirmPassword) {
          return AlertWarning({ text: "กรุณายืนยันรหัสผ่านให้ตรงกัน!" });
        } else {
          changePassword({ id, password: newPassword });
        }
      },
    });
  };

  return (
    <div style={backgroundStyle}>
      <div className="sg-section tw-h-screen tw-flex tw-justify-center tw-items-center">
        <div className="section-content">
          <div className="container">
            <div className="ragister-account text-center">
              <div className="row">
                <div className="col-lg-6">
                  <div className="account-content">
                    <div
                      style={{
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                      className="d-flex w-100"
                    >
                      <h1 className="w-100">เปลี่ยนรหัสผ่าน</h1>
                      <Link to="/" style={{ width: "200px" }}>
                        <u className="me-2">กลับสู่หน้าหลัก</u>
                      </Link>
                    </div>
                    <div className="ragister-form">
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          margin: "32px 0px",
                        }}
                      >
                        <img
                          style={{ width: "60px", height: "60px" }}
                          src={logo_mini_tonemusic}
                          alt="music icon"
                        />
                        <div className="ms-4 text-start">
                          <p style={header}>Tones Music</p>
                          <p style={text}>Education Course</p>
                        </div>
                      </div>

                      <div className="form-group text-left mb-0">
                        <label>รหัสผ่านใหม่</label>
                        <input
                          type="password"
                          className="form-control"
                          required="required"
                          placeholder="*****"
                          onChange={(e) => {
                            setNewPassword(e.target.value);
                          }}
                        />
                      </div>
                      <div className="form-group text-left mb-0">
                        <label>ยืนยันรหัสผ่านใหม่</label>
                        <input
                          type="password"
                          className="form-control"
                          required="required"
                          placeholder="*****"
                          onChange={(e) => {
                            setConfirmPassword(e.target.value);
                          }}
                        />
                      </div>
                      <Button
                        style={{ height: "45px" }}
                        type="primary"
                        className="w-100"
                        onClick={_handleResetPassword}
                      >
                        <p>เปลี่ยนรหัสผ่าน</p>
                      </Button>

                      <div className="middle-content my-2">
                        <p className="mb-2">
                          <Link
                            to="/forgetPassword"
                            className="text-primary ms-2"
                          >
                            ย้อนกลับ
                          </Link>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
